import { io } from 'socket.io-client';

import socketBaseUrl from './socketBaseUrl';

const socket = io(`${socketBaseUrl}/repricer-progress`, {
  transports: ['websocket'],
  autoConnect: false,
});

export default socket;
